export const schema = {
    title: 'Absence',
    type: 'object',
    required: ['absence_type', 'user_id', 'from', 'to', 'total_days', 'leave_type', 'start_time', 'end_time'],
    properties: {
        id: { type: 'integer' },
        user_id: { type: ['integer'], title: 'User', readOnly: true },
        client_id: { type: ['integer'], title: 'Client' },
        child: { type: ['string', 'null'], title: 'Child' },
        status: { type: ['string', 'null'], title: 'Status', default: 'active' },
        absence_type: { type: ['string'], title: 'Type' },
        total_days: { type: ['integer'], title: 'Total days', readOnly: true, default: 0 },
        absence_payment_per_day: { type: ['integer'], title: 'Enter Payment' },
        absence_total_payment: { type: ['number'], title: 'Total Payment', readOnly: true },
        from: { type: ['string'], format: 'date', title: 'From date' },
        to: { type: ['string'], format: 'date', title: 'To date' },
        attachments: { type: ['string', 'null'], title: 'Attachments' },
        leave_type: { type: ['string'], title: 'Leave Type', default: 'paid' },
        employement_grade: { type: 'number', title: 'Leave Percentage (%)', default: 100 },
        hours: { type: 'number', title: 'Hours', default: 0, readOnly: true },
        total_hours: { type: 'number', title: 'Total Hours', readOnly: true, default: 0 },
        project_id: { type: ['integer', 'null'], title: 'Project', default: 0 },
        start_time: { type: ['number', 'null'], title: 'Start time' },
        end_time: { type: ['number', 'null'], title: 'End time' },
        gps_data: { type: ['string', 'null'], title: 'GPS location', format: 'gps' },
        address: { type: ['string', 'null'], title: 'Address' },
        post_number: { type: ['string', 'null'], title: 'Zipcode', format: 'postnumber' },
        post_place: { type: ['string', 'null'], title: 'Post place' },
        is_work_related_leave: {
            type: 'boolean',
            title: 'Work Related',
            default: false,
            anyOf: [
                {
                    title: 'Yes',
                    enum: [true],
                },
                {
                    title: 'No',
                    enum: [false],
                },
            ],
        },
        social_welfare_leave_type: { type: ['string', 'null'], title: 'Social Welfare Leave Type' },
        data: {
            type: 'object',
            title: '',
            properties: {
                doctor_certification_date: {
                    type: ['string'],
                    format: 'date',
                    title: 'Medical Certificate Date',
                },
                medical_certification_percent: {
                    type: 'integer',
                    title: 'Medical certificate percentage',
                    default: 100
                },
            }
        },
        absence_info_group_error: { type: ['string', 'null'] }
    },
};

export const getSchema = (props) => {
    const schemaCopy = JSON.parse(JSON.stringify(schema));

    if (props && props.user_type && props.user_type === "member") {
        schemaCopy.properties.absence_payment_per_day.readOnly = true;
    }

    return schemaCopy;
};

export default getSchema;
